import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { notificationReducerActions } from "../../_services/store";
import {
    ErrorMessage,
    InfoMessage,
    SuccessMessage,
    WarningMessage,
} from "../../_UI/Components/Alerts/PathwayAlertMessages";
import styled from "styled-components";
import LoadingSpinner from "../../_UI/Components/LoadingSpinner";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";

const NotificationType = {
    ERROR: "ERROR",
    WARNING: "WARNING",
    SUCCESS: "SUCCESS",
    INFO: "INFO",
};

const MessageWrapper = (props) => {
    switch (props.type) {
        case NotificationType.ERROR:
            return <ErrorMessage messages={props.content} marginless />;
        case NotificationType.WARNING:
            return <WarningMessage messages={props.content} marginless />;
        case NotificationType.SUCCESS:
            return <SuccessMessage messages={props.content} marginless />;
        case NotificationType.INFO:
            return <InfoMessage messages={props.content} marginless />;
        default:
            return <></>;
    }
};

const NotificationModal = () => {
    const notificationReducer = useSelector((state) => state.notification);

    const dispatch = useDispatch();

    const navigate = useNavigate();
    const location = useLocation();

    const closeModal = useCallback(() => {
        const queryParams = new URLSearchParams(location.search);
        queryParams.delete("notificationId");
        navigate({
            search: queryParams.toString(),
            replace: true,
        });
        dispatch(notificationReducerActions.clearNotifications());
    }, [dispatch, location.search, navigate]);

    return (
        <Modal isOpen={notificationReducer.showModal} toggle={closeModal}>
            <ModalHeader toggle={closeModal}>
                {((notificationReducer.notification &&
                    notificationReducer.notification.type === NotificationType.ERROR) ||
                    (!(notificationReducer.notification && notificationReducer.notification.type) &&
                        notificationReducer.errorMessage)) &&
                    "Fehler"}
                {notificationReducer.notification &&
                    notificationReducer.notification.type === NotificationType.WARNING &&
                    "Warnung"}
                {notificationReducer.notification &&
                    notificationReducer.notification.type === NotificationType.SUCCESS &&
                    "Erfolg"}
                {notificationReducer.notification &&
                    notificationReducer.notification.type === NotificationType.INFO &&
                    "Hinweis"}
            </ModalHeader>
            <ModalBody>
                <Layout>
                    <LoadingSpinner loading={notificationReducer.loading} center={true} size="4em" />

                    <ErrorMessage marginless>{notificationReducer.errorMessage}</ErrorMessage>

                    {notificationReducer.notification && <MessageWrapper {...notificationReducer.notification} />}
                </Layout>
            </ModalBody>
        </Modal>
    );
};

export default NotificationModal;

const Layout = styled.div`
    display: grid;
    row-gap: var(--gap-l);
`;
